//
//
//
//
//
//
//
//
//
//
//

import LandingHero from '@/components/submission/LandingHero.vue';

export default {
  name: 'submission-landing',
  scrollToTop: true,
  components: {
    LandingHero,
    BaseBreadcrumbs: () => import('@/components/core/BaseBreadcrumbs.vue'),
    PageMeta: () => import('@motionelements/core/src/components/ThePageMeta.vue'),
  },
  computed: {
    pageTitle() {
      return this.$t('contributor.submission.call_for_submission');
    },
    pageDescription() {
      return this.$t('contributor.submission.call_for_submission_subheading');
    },
    breadcrumbList() {
      return [
        {
          name: this.$t('term.contributors'),
          link: this.$link('/contributors').fullPath(),
        },
        {
          name: this.$t('contributor.submission.call_for_submission'),
          link: this.$link('/call-for-submission').fullPath(),
          active: true,
        },
      ];
    },
  },
};
